module.exports = __webpack_public_path__ + "static/assets/e559f3a36902c9285228b7e842e75dc6.png";